/**
 * Created by shubham on 11/4/18.
 */

import {FileUploadListPage} from "./fileUploadList-page";

/**
 * An array of data with an associated page object used for paging
 */
export class FileUploadListPageData<T> {
    data = new Array<T>();
    page = new FileUploadListPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/file-upload/fileUploadList-datatable/fileUploadList-page-data.ts